/*
Video sobre VUEX
https://www.youtube.com/watch?v=i2yc_ACcMA0
*/

import Vuex from "vuex";
import Vue from "vue";
import {
  apiORDS,
  apiORDSapp,
  apiORDSpost,
  apiORDSauth,
  apiMetadata,
  apiORDSgetViaPost
} from "../shared/api-functions";

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    env: {
      email: "",
      token: null, //token ords
      apptoken: null, //token aplicacao com dados da conexao, empresa, usuario
      uuid: null, //uuid da empresa
      tpempresa: null
    },

    sessao: {},

    // urlApi: '/ords/webdata',
    // urlApp: '/ords/nbapp/',
    // urlLoja: '/ords/apiloja/',
    // urlNotifications: 'http://ec2-52-202-145-226.compute-1.amazonaws.com:3232',


    urlApi: "https://api.notabrasil.com.br/ords/webdata",
    urlApp: "https://api.notabrasil.com.br/ords/nbapp/",
    urlLoja: "https://api.notabrasil.com.br/ords/apiloja/",
    urlNotifications: "https://apinotification.notabrasil.com.br",

    // urlApi: 'https://teste.notabrasil.com.br/ords/webdata',
    // urlApp: 'https://teste.notabrasil.com.br/ords/nbapp/',
    // urlLoja: 'https://teste.notabrasil.com.br/ords/apiloja/',
    // urlNotifications: 'http://ec2-52-202-145-226.compute-1.amazonaws.com:3232',

    nextPage: 0, //controle de paginação de listas

    entities: {},

    parametrosUsuario: {},

    partList: {},
    part: {},
    partContato: {},
    partPainel: {},
    item: {},
    itemList: {},
    natesList: {},
    nates: {},
    itemSalesList: {},
    itemSalesVarejoList: {},
    itemTaxes: {},
    pedvList: {},
    pedvTotal: {},
    pedv: {},
    nfList: {},
    compraList: {},
    compra: {},
    nf_with_itemList: {},
    nfOrigem: {},
    nf: {},
    diList: {},
    duimpList: {},
    di: {},
    duimp: {},
    regrafcpList: {},
    regrafcp: {},
    regrast: {},
    regrastList: {},
    regraimp: {},
    regraimpList: {},
    grutribList: {},
    grutrib: {},
    estadoList: {},
    estado: {},
    ivancmList: {},
    ivancm: {},
    ivaclassList: {},
    ivaclass: {},

    unimedList: {},
    unimed: {},
    ncmList: {},
    ncm: {},
    gruestList: {},
    gruest: {},
    grucliList: {},
    grucli: {},
    xmlhistList: {},
    xmlhist: {},
    gruforList: {},
    grufor: {},
    mennfList: {},
    mennf: {},
    depositoList: {},
    deposito: {},
    vendList: {},
    vend: {},
    filialList: {},
    filial: {},
    usuarioList: {},
    usuario: {},
    natfinList: {},
    natfin: {},
    ramoatList: {},
    ramoat: {},
    contadorList: {},
    contador: {},
    serienfList: {},
    serienf: {},
    inutList: {},
    inut: {},
    nfAvisos: {},
    grade: {},
    gradeList: {},
    tabpre: {},
    tabpreList: {},
    tabpreItens: {},
    destaq: {},
    destaqList: {},
    tabdes: {},
    tabdesList: {},

    docsList: {},

    pdtipoList: {},
    pdtipo: {},
    pdstatusList: {},
    pdstatus: {},
    condicaoList: {},
    condicao: {},
    equipeList: {},
    equipe: {},
    agendaList: {},
    agenda: {},

    catmktList: {},
    catmkt: {},

    manifestoList: {},
    manifesto: {},

    guiaNFe: {},

    notificationsList: {},

    //FINANCEIRO
    ctaList: {},
    cta: {},
    fpagList: {},
    fpag: {},
    vcaixaList: {},
    vcaixa: {},
    bancoList: {},
    cnabSemVinculo: {},
    cnabPendente: {},
    cnabRemList: {},
    cnabRejList: {},
    cnabRetList: {},
    cnabRetDetList: {},
    fin: {},
    finarList: {},
    finarTotal: {}, //TOTALIZACAO CONTAS A RECEBER
    finapList: {}, //LISTAGEM CONTAS A PAGAR
    finapTotal: {}, //TOTALIZACOA CONTAS A PAGAR
    finExtratoList: {}, //EXTRATO FINANCEIRO DEBITOS E CREDITOS

    logList: {}, //TABLE DE LOG DE ALTERACOES DO SISTEMA

    templEmailList: [],
    templEmail: {},

    freteList: {},

    //CRM
    pessoa: {},
    pessoaList: {},
    organizacao: {},
    organizacaoList: {},
    negocio: {},
    negocioList: {},
    negocioNoDateTimelineList: {},
    negocioHist: {},
    negocioEmails: {},
    configCrm: {},
    tagCrm: {},
    origemCrm: {},
    origemCrmList: {},
    motivoCrm: {},
    motivoCrmList: {},
    funilCrm: {},
    emailCrm: {},
    emailCrmList: {},
    leadCrmList: [],
    leadCrm: {},
    // FIM CRM

    vDevolList: {},
    vDevol: {},

    // LOJA
    configLoja: {},
    // FIM LOJA

    paramPDV: {
      formato_venda_manual: "N",
      permite_desconto: "N",
      desconto_max: null,
      permite_acrescimo: "N",
      acrescimo_max: null,
      parcelas_somente_dias_uteis: "N",
      tabela_preco: null,
      altera_preco: null,
      exibe_opcao_gerar_sat: null,
      exibe_opcao_gerar_nfce: "S",
      tipo_controle_cm_ms: null,
      default_focus_btn_pag: null,
      default_header_title: null,
      observacao: null,
      ir_para_emissao_nf: "NV",
      colors: {
        bg_top_bottom: null,
        fc_top_bottom: null,
        bg_buttom: null,
        fc_buttom: null
      },
      listMesas: [],
      balanca: {
        numero_identificacao: null,
        tamanhobarra: null,
        inicio_codigo: null,
        fim_codigo: null,
        inicio_valor: null,
        fim_valor: null,
        barras_peso_ou_valor: null,
        qtd_casas_valor: null
      }
    },

    teste: {},

    indexfiltroTiposManifesto: 0,

    helpList: [
      {
        app: null,
        route: null,
        title: "Como renovar sua assinatura no Nota Brasil",
        icon: "fa-play",
        url: "//www.youtube.com/embed/JSFoOrlI4yo"
      },

      {
        app: ["nfe", "erp", "fv"],
        route: "partlist",
        title: "Como cadastrar clientes e fornecedores",
        icon: "fa-play",
        url: "//www.youtube.com/embed/Rb8ygl4dAqk"
      },

      // { app: ['nfe','erp'], route: 'partlist', title: 'Adicionar contatos', icon: 'fa-play', url: '//www.youtube.com/embed/Ji8TZTb04vk' },
      {
        app: ["nfe", "erp"],
        route: "partlist",
        title: "Importe seus clientes e fornecedores",
        icon: "fa-play",
        url: "//www.youtube.com/embed/ql3fiqp-Lvk"
      },
      // { app: ['nfe','erp'], route: 'partlist', title: 'Clientes com limite de crédito', icon: 'fa-play', url: '//www.youtube.com/embed/lUBvppUtM9U' },

      {
        app: ["nfe", "erp"],
        route: "gruforlist",
        title: "Cadastrar grupos de fornecedores",
        icon: "fa-play",
        url: "//www.youtube.com/embed/ybUK15Jvhrk"
      },

      {
        app: ["nfe", "erp"],
        route: "nfimportlist",
        title: "DI",
        icon: "fa-play",
        url: "//www.youtube.com/embed/PlH8n2h3_aw"
      },

      {
        app: ["nfe", "erp", "fv"],
        route: "fvprodutosmenu",
        title: "Como cadastrar produtos",
        icon: "fa-play",
        url: "//www.youtube.com/embed/c241at1ws14"
      },
      // { app: ['nfe','erp'], route: 'fvprodutosmenu', title: 'Produtos e configuração de impostos', icon: 'fa-play', url: '//www.youtube.com/embed/gjwdNe3q8AM' },
      {
        app: ["nfe", "erp", "fv"],
        route: "fvprodutosmenu",
        title: "Como importar produtos",
        icon: "fa-play",
        url: "//www.youtube.com/embed/6Bmo4YZTmII"
      },
      {
        app: ["nfe", "erp", "fv"],
        route: "fvprodutosmenu",
        title: "Grades",
        icon: "fa-play",
        url: "//www.youtube.com/embed/kjCvTcjM16o"
      },
      // { app: ['nfe','erp', 'fv'], route: 'fvprodutosmenu', title: 'Unidades de medida', icon: 'fa-play', url: '//www.youtube.com/embed/rZvRsuDRNSc' },

      {
        app: ["nfe", "erp"],
        route: "fvprodutosmenu",
        title: "Tabelas de desconto",
        icon: "fa-play",
        url: "//www.youtube.com/embed/atVVQ1Gp3PM"
      },
      {
        app: ["nfe", "erp"],
        route: "pedidolist",
        title: "Tabelas de desconto",
        icon: "fa-play",
        url: "//www.youtube.com/embed/atVVQ1Gp3PM"
      },
      {
        app: ["nfe", "erp"],
        route: "fvprodutosmenu",
        title: "Tabelas de preços",
        icon: "fa-play",
        url: "//www.youtube.com/embed/ZqW9c7_BQGE"
      },
      {
        app: ["nfe", "erp"],
        route: "pedidolist",
        title: "Tabelas de preços",
        icon: "fa-play",
        url: "//www.youtube.com/embed/ZqW9c7_BQGE"
      },

      {
        app: ["nfe", "erp", "fv"],
        route: "gradelist",
        title: "Grades",
        icon: "fa-play",
        url: "//www.youtube.com/embed/BogRiM2uBxM"
      },

      {
        app: ["nfe", "erp"],
        route: "nflist",
        title: "Como emitir notas de saída",
        icon: "fa-play",
        url: "//www.youtube.com/embed/UFfTZdJJdLw"
      },
      {
        app: ["nfe", "erp"],
        route: "nflist",
        title: "Como emitir uma carta de correção",
        icon: "fa-play",
        url: "//www.youtube.com/embed/O9OvFKti6cI"
      },
      {
        app: ["nfe", "erp"],
        route: "nflist",
        title: "Como cancelar uma NF-e emitida",
        icon: "fa-play",
        url: "//www.youtube.com/embed/9Vh3rEFh-MM"
      },
      {
        app: ["nfe", "erp"],
        route: "nflist",
        title: "Lançar notas de entrada de fornecedores",
        icon: "fa-play",
        url: "//www.youtube.com/embed/kZehwtZJpyc"
      },
      {
        app: ["nfe", "erp"],
        route: "nflist",
        title: "Importar XML de NF-e",
        icon: "fa-play",
        url: "//www.youtube.com/embed/9ObY3ziNqv4"
      },
      // { app: ['nfe','erp'], route: 'nflist', title: 'Cadastrar mensagens padrões para nota fiscal', icon: 'fa-play', url: '//www.youtube.com/embed/FaehFIR15t0' },
      {
        app: ["nfe", "erp"],
        route: "nflist",
        title: "Cadastrar naturezas de operação",
        icon: "fa-play",
        url: "//www.youtube.com/embed/vwmjvWBc6cM"
      },
      {
        app: ["nfe", "erp"],
        route: "nflist",
        title: "Regras de ICMS",
        icon: "fa-play",
        url: "//www.youtube.com/embed/c7K1Pt9KY8M"
      },

      {
        app: ["nfe", "erp"],
        route: "inutlist",
        title: "Como inutilizar numeração de NF-e",
        icon: "fa-play",
        url: "//www.youtube.com/embed/tobpmc34LBA"
      },

      {
        app: ["nfe", "erp", "fv"],
        route: "pedidolist",
        title: "Lançar uma venda",
        url: "//www.youtube.com/embed/oDczqdHbDUc"
      },

      {
        app: ["nfe", "erp"],
        route: "regraimplist",
        title: "Regras de ICMS",
        icon: "fa-play",
        url: "//www.youtube.com/embed/c7K1Pt9KY8M"
      },

      {
        app: ["nfe", "erp", "fv"],
        route: "filiallist",
        title: "Configure os dados da sua empresa",
        icon: "fa-play",
        url: "//www.youtube.com/embed/0QMVqSEm-ww"
      },
      {
        app: ["nfe", "erp", "fv"],
        route: "filiallist",
        title: "Vincular um certificado A3",
        icon: "fa-play",
        url: "//www.youtube.com/embed/Ds6DmZ7uzEg"
      },
      {
        app: ["nfe", "erp", "fv"],
        route: "filiallist",
        title: "Vincular um certificado A1",
        icon: "fa-play",
        url: "//www.youtube.com/embed/S6QsrgWAaRM"
      },
      {
        app: ["nfe", "erp", "fv"],
        route: "configmenu",
        title: "Configure os dados da sua empresa",
        icon: "fa-play",
        url: "//www.youtube.com/embed/0QMVqSEm-ww"
      },
      {
        app: ["nfe", "erp", "fv"],
        route: "configmenu",
        title: "Vincular um certificado A3",
        icon: "fa-play",
        url: "//www.youtube.com/embed/Ds6DmZ7uzEg"
      },
      {
        app: ["nfe", "erp", "fv"],
        route: "configmenu",
        title: "Vincular um certificado A1",
        icon: "fa-play",
        url: "//www.youtube.com/embed/S6QsrgWAaRM"
      },

      {
        app: ["nfe", "erp", "fv"],
        route: "usuariolist",
        title: "Cadastrar novos usuários",
        icon: "fa-play",
        url: "//www.youtube.com/embed/zrLh76xUIcM"
      },

      {
        app: ["nfe", "erp"],
        route: "regrafcplist",
        title: "Alíquotas do FCP",
        icon: "fa-play",
        url: "//www.youtube.com/embed/iDViSF1rOYk"
      },

      {
        app: ["nfe", "erp"],
        route: "nateslist",
        title: "Cadastrar naturezas de operação",
        icon: "fa-play",
        url: "//www.youtube.com/embed/vwmjvWBc6cM"
      }
    ]
  };
};

export const store = new Vuex.Store({
  state: getDefaultState(),

  getters: {
    urlOrdsSelect: function(state) {
      return state.urlApi + "/select/";
    },
    urlOrds: function(state) {
      return state.urlApi + "/";
    },
    urlApp: function(state) {
      return state.urlApp;
    },
    urlLoja: function(state) {
      return state.urlLoja;
    },
    urlMetadata: function(state) {
      return state.urlApp + "metadata/";
    },
    urlNotifications: function(state) {
      return state.urlNotifications;
    },
    getEnv: function(state) {
      return state.env;
    },
    getEnvAcessoCore: function(state) {
      return (
        state.env.email == "teste@gmail.com" ||
        state.env.email == "rodrigosaso@terra.com.br"
      );
    },
    getSessao: function(state) {
      return state.sessao;
    },
    getToken: function(state) {
      return state.env.token;
    },
    getEntities: function(state) {
      return state.entities;
    },
    getParametrosUsuario: function(state) {
      return state.parametrosUsuario;
    },
    getNextPage: function(state) {
      return state.nextPage;
    },
    getMessages: function(state) {
      return state.entities.messages;
    },
    getHelpList: function(state) {
      return state.helpList;
    },
    getPartList: function(state) {
      return state.partList;
    },
    getPart: function(state) {
      return state.part;
    },
    getPartContato: function(state) {
      return state.partContato;
    },
    getPartPainel: function(state) {
      return state.partPainel;
    },
    getItem: function(state) {
      return state.item;
    },
    getItemList: function(state) {
      return state.itemList;
    },
    getItemSalesVarejoList: function(state) {
      return state.itemSalesVarejoList;
    },
    getItemSalesList: function(state) {
      return state.itemSalesList;
    },
    getItemTaxes: function(state) {
      return state.itemTaxes;
    },
    getNatesList: function(state) {
      return state.natesList;
    },
    getNatesSaidaList: function(state) {
      if (state.natesList && state.natesList.length)
        return state.natesList.filter(nates => {
          return !nates.tpnat || nates.tpnat == "" || nates.tpnat == "S";
        });
    },
    getNatesEntradaList: function(state) {
      if (state.natesList && state.natesList.length)
        return state.natesList.filter(nates => {
          return nates.tpnat == "E";
        });
    },
    getNates: function(state) {
      return state.nates;
    },
    getPedvList: function(state) {
      return state.pedvList;
    },
    getPedvTotal: function(state) {
      return state.pedvTotal;
    },
    getPedv: function(state) {
      return state.pedv;
    },
    getPedvDev: function(state) {
      return state.pedvDev;
    },
    getvDevolList: function(state) {
      return state.vDevolList;
    },
    getVdevol: function(state) {
      return state.vDevol;
    },
    getNfList: function(state) {
      return state.nfList;
    },
    getCompraList: function(state) {
      return state.compraList
    },
    getCompra: function(state) {
      return state.compra
    },
    getNf_with_itemList: function(state) {
      return state.nf_with_itemList;
    },

    getNfOrigem: function(state) {
      return state.nfOrigem;
    },
    getNf: function(state) {
      return state.nf;
    },
    getDiList: function(state) {
      return state.diList;
    },
    getDuimpList: function(state) {
      return state.duimpList
    },

    getDi: function(state) {
      return state.di;
    },
    getDuimp: function(state) {
      return state.duimp
    },

    getRegrast: function(state) {
      return state.regrast;
    },
    getRegrastList: function(state) {
      return state.regrastList;
    },
    getRegraimp: function(state) {
      return state.regraimp;
    },
    getRegraimpList: function(state) {
      return state.regraimpList;
    },
    getGrutrib: function(state) {
      return state.grutrib;
    },
    getGrutribList: function(state) {
      return state.grutribList;
    },
    getRegrafcp: function(state) {
      return state.regrafcp;
    },
    getRegrafcpList: function(state) {
      return state.regrafcpList;
    },
    getEstadoList: function(state) {
      return state.estadoList;
    },
    getEstado: function(state) {
      return state.estado;
    },
    getivancmList: function(state) {
      return state.ivancmList;
    },
    getivancm: function(state) {
      return state.ivancm;
    },
    getivaclassList: function(state) {
      return state.ivaclassList;
    },
    getivaclass: function(state) {
      return state.ivaclass;
    },
    getUnimedList: function(state) {
      return state.unimedList;
    },
    getUnimed: function(state) {
      return state.unimed;
    },
    getNcmList: function(state) {
      return state.ncmList;
    },
    getNcm: function(state) {
      return state.ncm;
    },
    getGruestList: function(state) {
      return state.gruestList;
    },
    getGruest: function(state) {
      return state.gruest;
    },
    getGrucliList: function(state) {
      return state.grucliList;
    },
    getGrucli: function(state) {
      return state.grucli;
    },
    getXMLHistList: function(state) {
      return state.xmlhistList;
    },
    getXMLHist: function(state) {
      return state.xmlhist;
    },
    getGruforList: function(state) {
      return state.gruforList;
    },
    getGrufor: function(state) {
      return state.grufor;
    },
    getMennf: function(state) {
      return state.mennf;
    },
    getMennfList: function(state) {
      return state.mennfList;
    },
    getDeposito: function(state) {
      return state.deposito;
    },
    getDepositoList: function(state) {
      return state.depositoList;
    },
    getFilial: function(state) {
      return state.filial;
    },
    getFilialList: function(state) {
      return state.filialList;
    },
    getVend: function(state) {
      return state.vend;
    },
    getVendList: function(state) {
      return state.vendList;
    },
    getUsuario: function(state) {
      return state.usuario;
    },
    getUsuarioList: function(state) {
      return state.usuarioList;
    },
    getSerienf: function(state) {
      return state.serienf;
    },
    getSerienfList: function(state) {
      return state.serienfList;
    },
    getContador: function(state) {
      return state.contador;
    },
    getContadorList: function(state) {
      return state.contadorList;
    },
    getNatfin: function(state) {
      return state.natfin;
    },
    getNatfinList: function(state) {
      return state.natfinList;
    },
    getRamoat: function(state) {
      return state.ramoat;
    },
    getRamoatList: function(state) {
      return state.ramoatList;
    },
    getInut: function(state) {
      return state.inut;
    },
    getInutList: function(state) {
      return state.inutList;
    },
    getNfAvisos: function(state) {
      return state.nfAvisos;
    },
    getCta: function(state) {
      return state.cta;
    },
    getCtaList: function(state) {
      return state.ctaList;
    },
    getFpag: function(state) {
      return state.fpag;
    },
    getFpagList: function(state) {
      return state.fpagList;
    },
    getVCaixa: function(state) {
      return state.vcaixa;
    },
    getVCaixaList: function(state) {
      return state.vcaixaList;
    },
    getBancoList: function(state) {
      return state.bancoList;
    },
    getCnabSemVinculo: function(state) {
      return state.cnabSemVinculo;
    },
    getCnabPendente: function(state) {
      return state.cnabPendente;
    },
    getCnabRemList: function(state) {
      return state.cnabRemList;
    },
    getCnabRejList: function(state) {
      return state.cnabRejList;
    },
    getCnabRetList: function(state) {
      return state.cnabRetList;
    },
    getCnabRetDetList: function(state) {
      return state.cnabRetDetList;
    },
    getFin: function(state) {
      return state.fin;
    },
    getLogList: function(state) {
      return state.logList;
    },
    getGrade: function(state) {
      return state.grade;
    },
    getGradeList: function(state) {
      return state.gradeList;
    },
    getTabpre: function(state) {
      return state.tabpre;
    },
    getTabpreList: function(state) {
      return state.tabpreList;
    },
    getTabpreItens: function(state) {
      return state.tabpreItens;
    },
    getDestaq: function(state) {
      return state.destaq;
    },
    getDestaqList: function(state) {
      return state.destaqList;
    },
    getTabdes: function(state) {
      return state.tabdes;
    },
    getTabdesList: function(state) {
      return state.tabdesList;
    },

    getDocsList: function(state) {
      return state.docsList;
    },

    getPdtipoList: function(state) {
      return state.pdtipoList;
    },
    getPdtipo: function(state) {
      return state.pdtipo;
    },
    getPdstatusList: function(state) {
      return state.pdstatusList;
    },
    getPdstatus: function(state) {
      return state.pdstatus;
    },
    getCondicaoList: function(state) {
      return state.condicaoList;
    },
    getCondicao: function(state) {
      return state.condicao;
    },
    getEquipeList: function(state) {
      return state.equipeList;
    },
    getEquipe: function(state) {
      return state.equipe;
    },
    getAgendaList: function(state) {
      return state.agendaList;
    },
    getAgenda: function(state) {
      return state.agenda;
    },
    getCatmktList: function(state) {
      return state.catmktList;
    },
    getCatmkt: function(state) {
      return state.catmkt;
    },
    getPessoa: function(state) {
      return state.pessoa;
    },
    getPessoaList: function(state) {
      return state.pessoaList;
    },
    getOrganizacao: function(state) {
      return state.organizacao;
    },
    getOrganizacaoList: function(state) {
      return state.organizacaoList;
    },
    getNegocio: function(state) {
      return state.negocio;
    },
    getNegocioList: function(state) {
      return state.negocioList;
    },
    getNegocioNoDateTimelineList: function(state) {
      return state.negocioNoDateTimelineList;
    },
    getNegocioHist: function(state) {
      return state.negocioHist;
    },
    getNegocioEmails: function(state) {
      return state.negocioEmails;
    },
    getEmailCrm: function(state) {
      return state.emailCrm;
    },
    getEmailCrmList: function(state) {
      return state.emailCrmList;
    },
    getLeadCrm: function(state) {
      return state.leadCrm;
    },
    getLeadCrmList: function(state) {
      return state.leadCrmList;
    },
    getNegocioTotais: function(state) {
      return state.negocioTotais;
    },
    getConfigCrm: function(state) {
      return state.configCrm;
    },
    getTagCrm: function(state) {
      return state.tagCrm;
    },
    getOrigemCrm: function(state) {
      return state.origemCrm;
    },
    getOrigemCrmList: function(state) {
      return state.origemCrmList;
    },
    getFunilCrm: function(state) {
      return state.funilCrm;
    },
    getMotivoCrm: function(state) {
      return state.motivoCrm;
    },
    getMotivoCrmList: function(state) {
      return state.motivoCrmList;
    },
    getTemplEmail: function(state) {
      return state.templEmail;
    },
    getTemplEmailList: function(state) {
      return state.templEmailList;
    },
    getManifestoList: function(state) {
      return state.manifestoList;
    },
    getManifesto: function(state) {
      return state.manifesto;
    },
    getFreteList: function(state) {
      return state.freteList;
    },

    getGuiaNFe: function(state) {
      return state.guiaNFe;
    },
    getNotificationsList: function(state) {
      return state.notificationsList;
    },

    // LOJA

    getConfigLoja: function(state) {
      return state.configLoja;
    },

    // FIM LOJA

    // PARAMETROS PDV

    getParamPDV: function(state) {
      return state.paramPDV;
    },

    getTeste: function(state) {
      return state.teste;
    },

    getIndexfiltroTiposManifesto: function(state) {
      return state.indexfiltroTiposManifesto;
    }
  },

  mutations: {
    LOAD_ENV(state, data) {
      if (data.auth && data.auth.access_token) {
        state.env.token = data.auth.access_token;
      } else {
        state.env.token = null;
      }
      state.env.apptoken = data.login.apptoken;
      state.env.uuid = data.login.uuid;
      state.env.empresanome = data.login.empresanome;
      state.env.empresacod = data.login.empresacod;
      state.env.usuarionome = data.login.usuarionome;
      state.env.email = data.login.email;
      state.env.tpempresa = data.login.tpempresa;
      state.urlApi = data.login.urlapi;
      // state.urlApi = 'https://novo.notabrasil.com.br' + data.login.urlapi
      //armazena o objeto de autenticacao para utilizar ao recarregar a pagina
      window.sessionStorage.setItem("authObj", JSON.stringify(data));
    },
    LOAD_SESSAO(state, data) {
      state.sessao = {};
      if (data.items) {
        state.sessao = data.items[0];
      }
    },
    LOGOUT(state) {
      //remove a autenticacao para efetuar novo login
      Object.assign(state, getDefaultState());

      // state.env = {}
      window.sessionStorage.removeItem("authObj");
    },
    LOAD_METADATA(state, entities) {
      state.entities = entities;
    },
    LOAD_PARTLIST(state, data) {
      if (data.offset > 0) {
        const newItems = data.items.filter(newItem => !state.partList.some(existingItem => existingItem.codpart === newItem.codpart));
        state.partList = state.partList.concat(newItems);
      } else {
        state.partList = data.items;
      }
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_PARAMETROSUSUARIO(state, data) {
      state.parametrosUsuario = data;
    },
    LOAD_PART(state, data) {
      state.part = data;
    },
    LOAD_PARTCONTATO(state, data) {
      state.partContato = data;
    },
    LOAD_PARTPAINEL(state, data) {
      state.partPainel = data;
    },
    LOAD_ITEM(state, data) {
      state.item = data.items;
    },
    LOAD_ITEMLIST(state, data) {
      if (data.offset > 0) {
        const newItems = data.items.filter(newItem => !state.itemList.some(existingItem => existingItem.coditem === newItem.coditem));
        state.itemList = state.itemList.concat(newItems);
      } else {
        state.itemList = data.items;
      }
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_ITEMSALESLIST(state, data) {
      if (data.items.length > 0 && data.items[0].tabelas_preco) {
        for (var x = 0; x < data.items.length; x++) {
          data.items[x].tabelas_preco = JSON.parse(
            data.items[x].tabelas_preco_json
          );
          if (!data.items[x].tabelas_preco)
            data.items[x].tabelas_preco = { tabelas: [] };
        }
      }

      if (data.offset > 0)
        state.itemSalesList = state.itemSalesList.concat(data.items);
      else state.itemSalesList = data.items;

      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    CLEAR_ITEMSALESLIST(state) {
      state.itemSalesList = {};
    },
    LOAD_ITEMSALESVAREJOLIST(state, data) {
      if (data.items.length > 0 && data.items[0].tabelas_preco) {
        for (var x = 0; x < data.items.length; x++) {
          data.items[x].tabelas_preco = JSON.parse(
            data.items[x].tabelas_preco_json
          );
          if (!data.items[x].tabelas_preco)
            data.items[x].tabelas_preco = { tabelas: [] };
        }
      }

      if (data.offset > 0)
        state.itemSalesVarejoList = state.itemSalesVarejoList.concat(
          data.items
        );
      else state.itemSalesVarejoList = data.items;

      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    CLEAR_ITEMSALESVAREJOLIST(state) {
      state.itemSalesVarejoList = {};
    },
    CLEAR_ITEMLIST(state) {
      state.itemList = {};
    },
    LOAD_ITEMTAXES(state, data) {
      state.itemTaxes = data;
    },
    LOAD_NATES(state, data) {
      state.nates = data.items[0];
    },
    LOAD_NATESLIST(state, data) {
      state.natesList = data.items;
    },
    LOAD_PEDVLIST(state, data) {
      //if (((data.offset) && (parseInt(data.offset) > 0)) || ((data.nextPage) && (parseInt(data.nextPage) > 0)))
      //  state.pedvList = state.pedvList.concat(data.items)
      //else

      if (data.nextPage && parseInt(data.nextPage) > 0) {
        const newItems = data.items.filter(newItem => !state.pedvList.some(existingItem => existingItem.codpedv === newItem.codpedv));
        state.pedvList = state.pedvList.concat(newItems);
      } else {
        state.pedvList = data.items;
      }

      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage =
          (parseInt(data.limit) || 0) + (parseInt(data.nextPage) || 0);
      }

      //state.nextPage = 0
      //if (data.hasMore == "true") {
      //  if (data.offset)
      //    state.nextPage = parseInt(data.limit) + parseInt(data.offset)
      //  if (data.nextPage)
      //    state.nextPage = parseInt(data.limit) + parseInt(data.nextPage)
      //}
    },
    LOAD_PEDVTOTAL(state, data) {
      state.pedvTotal = data.items;
    },
    LOAD_PEDV(state, items) {
      state.pedv = items;
    },
    LOAD_PEDVATUALUSUARIO(state, data) {
      state.pedv = data;
    },
    LOAD_VDEVOL(state, items) {
      state.vDevol = items;
    },
    LOAD_VDEVOLLIST(state, data) {
      state.vDevolList = data.items;
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_NFLIST(state, data) {
      state.nfList = data.items;
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_COMPRALIST(state, data) {
      if (data.offset > 0)
        state.compraList = state.compraList.concat(data.items)
      else
        state.compraList = data.items
      state.nextPage = 0
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset
      }
    },
    LOAD_COMPRA(state, data) {
      state.compra = data.items[0]
      if (!state.compra.comprait) state.compra.comprait = []
      if (!state.compra.comprapar) state.compra.comprapar = []
    },
    LOAD_NF_WITH_ITEMLIST(state, data) {
      state.nf_with_itemList = data.items;
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },

    LOAD_LISTNF(state, data) {
      state.nfList = data.items;
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_NFORIGEM(state, data) {
      state.nfOrigem = data.items;
    },
    LOAD_NF(state, items) {
      state.nf = items;
    },
    LOAD_DILIST(state, data) {
      state.diList = data.items;
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_DI(state, items) {
      state.di = items;
    },
    LOAD_DUIMPLIST(state, data) {
      state.duimpList = data.items
      state.nextPage = 0
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset
      }
    },
    LOAD_DUIMP(state, items) {
      state.duimp = items
    },

    LOAD_REGRAFCP(state, data) {
      state.regrafcp = data.items[0];
    },
    LOAD_REGRAFCPLIST(state, data) {
      state.regrafcpList = data.items;
    },
    LOAD_REGRAST(state, items) {
      state.regrast = items;
    },
    LOAD_REGRASTLIST(state, items) {
      state.regrastList = items;
    },
    LOAD_REGRAIMP(state, items) {
      state.regraimp = items;
    },
    LOAD_REGRAIMPLIST(state, items) {
      state.regraimpList = items;
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_GRUTRIB(state, data) {
      state.grutrib = data.items[0];
    },
    LOAD_GRUTRIBLIST(state, data) {
      state.grutribList = data.items;
    },
    LOAD_ESTADOLIST(state, data) {
      state.estadoList = data.items;
    },
    LOAD_ESTADO(state, data) {
      state.estado = data.items[0];
    },
    LOAD_IVANCMLIST(state, data) {
      state.ivancmList = data.items;
    },
    LOAD_IVANCM(state, data) {
      state.ivancm = data.items[0];
    },
    LOAD_IVACLASSLIST(state, data) {
      state.ivaclassList = data.items;
    },
    LOAD_IVACLASS(state, data) {
      state.ivaclass = data.items[0];
    },
    LOAD_UNIMEDLIST(state, items) {
      state.unimedList = items;
    },
    LOAD_UNIMED(state, items) {
      state.unimed = items;
    },
    LOAD_NCMLIST(state, data) {
      state.ncmList = data.items;
      state.nextPage = 0;
      if (data.hasMore) {
        state.nextPage = data.limit + data.offset;
      }
    },
    LOAD_NCM(state, items) {
      state.ncm = items;
    },
    LOAD_GRUESTLIST(state, data) {
      state.gruestList = data.items;
    },
    LOAD_GRUEST(state, data) {
      state.gruest = data.items[0];
    },
    LOAD_GRUFORLIST(state, data) {
      state.gruforList = data.items;
    },
    LOAD_GRUFOR(state, data) {
      state.grufor = data.items[0];
    },
    LOAD_GRUCLILIST(state, data) {
      state.grucliList = data.items;
    },
    LOAD_GRUCLI(state, data) {
      state.grucli = data.items[0];
    },
    LOAD_XMLHISTLIST(state, data) {
      state.xmlhistList = data.items;
    },
    LOAD_XMLHIST(state, data) {
      state.xmlhist = data.items[0];
    },
    LOAD_MENNFLIST(state, data) {
      state.mennfList = data.items;
    },
    LOAD_MENNF(state, data) {
      state.mennf = data.items[0];
    },
    LOAD_VENDLIST(state, data) {
      state.vendList = data.items;
    },
    LOAD_VEND(state, data) {
      state.vend = data.items[0];
    },
    LOAD_FILIALLIST(state, data) {
      state.filialList = data.items;
    },
    LOAD_FILIAL(state, data) {
      state.filial = data.items[0];
    },
    LOAD_USUARIOLIST(state, data) {
      state.usuarioList = data.items;
    },
    LOAD_USUARIO(state, data) {
      state.usuario = data.items[0];
    },
    LOAD_DEPOSITOLIST(state, data) {
      state.depositoList = data.items;
    },
    LOAD_DEPOSITO(state, data) {
      state.deposito = data.items[0];
    },
    LOAD_SERIENFLIST(state, data) {
      state.serienfList = data.items;
    },
    LOAD_SERIENF(state, data) {
      state.serienf = data.items[0];
    },
    LOAD_CONTADORLIST(state, data) {
      state.contadorList = data.items;
    },
    LOAD_CONTADOR(state, data) {
      state.contador = data.items[0];
    },
    LOAD_NATFINLIST(state, data) {
      state.natfinList = data.items;
    },
    LOAD_NATFIN(state, data) {
      state.natfin = data.items[0];
    },
    LOAD_RAMOATLIST(state, data) {
      state.ramoatList = data.items;
    },
    LOAD_RAMOAT(state, data) {
      state.ramoat = data.items[0];
    },
    LOAD_INUTLIST(state, data) {
      state.inutList = data.items;
    },
    LOAD_NFAVISOS(state, data) {
      state.nfAvisos = data.items;
    },
    LOAD_INUT(state, data) {
      state.inut = data.items[0];
    },
    LOAD_CTALIST(state, data) {
      state.ctaList = data.items;
    },
    LOAD_CTA(state, data) {
      state.cta = data.items[0];
    },
    LOAD_FPAGLIST(state, data) {
      state.fpagList = data.items;
    },
    LOAD_FPAG(state, data) {
      state.fpag = data.items[0];
    },
    LOAD_VCAIXALIST(state, data) {
      state.vcaixaList = data.items;
    },
    LOAD_VCAIXA(state, data) {
      state.vcaixa = data.items[0];
    },
    LOAD_BANCO(state, data) {
      state.bancoList = data.items;
    },
    LOAD_CNABSEMVINCULO(state, data) {
      state.cnabSemVinculo = data.items;
    },
    LOAD_CNABPENDENTE(state, data) {
      state.cnabPendente = data.items;
    },
    LOAD_CNABREMLIST(state, data) {
      state.cnabRemList = data.items;
    },
    LOAD_CNABREJLIST(state, data) {
      state.cnabRejList = data.items;
    },
    LOAD_CNABRETLIST(state, data) {
      state.cnabRetList = data.items;
    },
    LOAD_CNABRETDETLIST(state, data) {
      state.cnabRetDetList = data.items;
    },
    LOAD_FIN(state, data) {
      state.fin = data.items[0];
    },
    LOAD_LOG(state, data) {
      state.logList = data.items;
    },
    LOAD_GRADELIST(state, data) {
      state.gradeList = data.items;
    },
    LOAD_GRADE(state, data) {
      state.grade = data.items[0];
    },
    LOAD_DESTAQLIST(state, data) {
      state.destaqList = data.items;
    },
    LOAD_DESTAQ(state, data) {
      state.destaq = data.items[0];
    },
    LOAD_TABDESLIST(state, data) {
      state.tabdesList = data.items;
    },
    LOAD_TABDES(state, data) {
      state.tabdes = data.items[0];
    },
    LOAD_TABPREITENS(state, data) {
      state.tabpreItens = data.items;
    },
    LOAD_TABPRELIST(state, data) {
      state.tabpreList = data.items;
    },
    LOAD_TABPRE(state, data) {
      state.tabpre = data.items[0];
    },
    LOAD_DOCS(state, data) {
      state.docsList = data.items;
    },

    LOAD_PDTIPOLIST(state, data) {
      state.pdtipoList = data.items;
    },
    LOAD_PDTIPO(state, data) {
      state.pdtipo = data.items[0];
    },
    LOAD_PDSTATUSLIST(state, data) {
      state.pdstatusList = data.items;
    },
    LOAD_PDSTATUS(state, data) {
      state.pdstatus = data.items[0];
    },
    LOAD_CONDICAOLIST(state, data) {
      state.condicaoList = data.items;
    },
    LOAD_CONDICAO(state, data) {
      state.condicao = data.items[0];
    },
    LOAD_EQUIPELIST(state, data) {
      state.equipeList = data.items;
    },
    LOAD_EQUIPE(state, data) {
      state.equipe = data.items[0];
    },
    LOAD_AGENDALIST(state, data) {
      state.agendaList = data.items;
    },
    LOAD_AGENDA(state, data) {
      state.agenda = data.items[0];
    },
    LOAD_CATMKTLIST(state, data) {
      state.catmktList = data.items;
    },
    LOAD_CATMKT(state, data) {
      state.catmkt = data.items[0];
    },
    LOAD_PESSOALIST(state, data) {
      state.pessoaList = data.items;
    },
    LOAD_PESSOA(state, data) {
      state.pessoa = data.items[0];
    },
    LOAD_ORGANIZACAOLIST(state, data) {
      state.organizacaoList = data.items;
    },
    LOAD_ORGANIZACAO(state, data) {
      state.organizacao = data.items[0];
    },
    LOAD_NEGOCIOLIST(state, data) {
      state.negocioList = data.items;
    },
    LOAD_NEGOCIONODATELIST(state, data) {
      if (data.items.length > 0)
        state.negocioNoDateTimelineList = data.items[0];
    },
    LOAD_NEGOCIOHIST(state, data) {
      state.negocioHist = data.items;
    },
    LOAD_NEGOCIOEMAILS(state, data) {
      state.negocioEmails = data.items;
    },
    LOAD_EMAILCRM(state, data) {
      state.emailCrm = data.items[0];
    },
    LOAD_EMAILCRMLIST(state, data) {
      state.emailCrmList = data.items;
    },
    LOAD_LEADCRM(state, data) {
      state.leadCrm = data.items[0];
    },
    LOAD_LEADCRMLIST(state, data) {
      state.leadCrmList = data.items;
    },
    LOAD_NEGOCIOTOTAIS(state, data) {
      state.negocioTotais = data.items;
    },
    LOAD_NEGOCIO(state, data) {
      state.negocio = data.items[0];
    },
    LOAD_CONFIGCRM(state, data) {
      state.configCrm = data.items[0];
    },
    LOAD_TAGCRM(state, data) {
      state.tagCrm = data.items[0];
    },
    LOAD_ORIGEMCRM(state, data) {
      state.origemCrm = data.items[0];
    },
    LOAD_ORIGEMCRMLIST(state, data) {
      state.origemCrmList = data.items;
    },
    LOAD_MOTIVOCRM(state, data) {
      state.motivoCrm = data.items[0];
    },
    LOAD_MOTIVOCRMLIST(state, data) {
      state.motivoCrmList = data.items;
    },
    LOAD_FUNILCRM(state, data) {
      state.funilCrm = data.items[0];
    },

    LOAD_TEMPLEMAIL(state, data) {
      state.templEmail = data.items[0];
    },
    LOAD_TEMPLEMAILLIST(state, data) {
      state.templEmailList = data.items;
    },

    LOAD_CONFIGLOJA(state, data) {
      state.configLoja = data.items[0];
    },

    LOAD_GUIANFE(state, data) {
      state.guiaNFe = data;
    },

    LOAD_NOTIFICATIONSLIST(state, data) {
      if (data.offset > 0)
        state.notificationsList = state.notificationsList.concat(data.items);
      else state.notificationsList = data.items;
      state.nextPage = 0;

      if (data.hasMore) {
        state.nextPage = parseInt(data.limit) + parseInt(data.offset);
      }
    },

    LOAD_TESTE(state, data) {
      state.teste = data.items;
    },

    CLEAN_PART(state) {
      state.partList = {};
      state.part = {};
    },

    LOAD_MANIFESTOLIST(state, data) {
      state.manifestoList = data.items;
    },
    LOAD_MANIFESTO(state, data) {
      state.manifesto = data.items[0];
    },

    LOAD_FRETELIST(state, data) {
      state.freteList = data.items;
    },

    SET_INDEXFILTROTIPOSMANIFESTO: function(state, data) {
      state.indexfiltroTiposManifesto = data;
    }
  },

  actions: {
    async loadEnv({ commit }, data) {
      commit("LOAD_ENV", data);
    },

    async loadSessao({ commit }, vm) {
      const data = await apiORDSapp(vm, "sessao/", "get", null);
      commit("LOAD_SESSAO", data);
    },

    async logout({ commit }) {
      commit("LOGOUT");
    },

    async loadMetadata({ commit }) {
      const entities = await apiMetadata(this.getters.urlMetadata);
      commit("LOAD_METADATA", entities);
    },

    async loadParametrosUsuario({ commit }) {
      const data = await apiORDS(
        this.getters.urlOrds + "sales/parametros_usuario",
        {}
      );
      if (data.items.length && data.items[0].parametros) {
        commit("LOAD_PARAMETROSUSUARIO", JSON.parse(data.items[0].parametros));
      } else {
        commit("LOAD_PARAMETROSUSUARIO", {});
      }
    },

    async loadUsuariosDashboard({ commit }) {
      const data = await apiORDS(
        this.getters.urlOrds + "dashboard/usuarios",
        {},
        true
      );
      if (data.items) {
        commit("LOAD_USUARIOLIST", data);
      }
    },

    async loadEquipesDashboard({ commit }) {
      const data = await apiORDS(
        this.getters.urlOrds + "dashboard/equipes",
        {},
        true
      );
      if (data.items) {
        commit("LOAD_EQUIPELIST", data);
      }
    },

    //PARTICIPANTES
    async loadPart({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/part/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_PART", data.items);
        } else {
          commit("LOAD_PARTLIST", data);
        }
      }
    },

    //TRANSPORTADORAS
    async loadTransportadoras({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "cg/part/transportadoras/",
        params
      );
      if (data.items) {
        if (params.id) {
          commit("LOAD_PART", data.items);
        } else {
          commit("LOAD_PARTLIST", data);
        }
      }
    },

    async loadPartDoc({ commit }, params) {
      let url =
        this.getters.urlOrds +
        "cg/part/" +
        params.tppessoa +
        "/" +
        params.cnpjcpf;
      const data = await apiORDS(url);
      if (data.items) {
        commit("LOAD_PART", data.items);
      }
    },

    async loadPartPainel({ commit }, params) {
      let url = this.getters.urlOrds + "cg/part/" + params.id + "/painel/";
      const data = await apiORDS(url);
      if (data.items && data.items.length) {
        commit("LOAD_PARTPAINEL", data.items[0]);
      }
    },

    async loadCliente({ commit }, params) {
      let modulo = "select/cliente2/";
      if (params.participante) modulo = "select/participante/";
      else if (params.forcaVendas) modulo = "select/forcavendas/cliente2/";
      const data = await apiORDS(this.getters.urlOrds + modulo, params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_PART", data.items);
        } else {
          commit("LOAD_PARTLIST", data);
        }
      }
    },

    //CONTATO DE PARTICIPANTES
    async loadPartcontato({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "cg/partcontato/" + params.codpart + "/",
        params
      );
      if (data.items) {
        if (params.id) {
          commit("LOAD_PARTCONTATO", data.items);
        }
      }
    },

    //ITENS
    async loadItem({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/item/", params);
      if (data.items) {
        commit("LOAD_ITEM", data);
      }
    },

    async loadItemList({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/item/", params);
      if (data.items) {
        commit("LOAD_ITEMLIST", data);
      }
    },

    async loadItemSales({ commit }, params) {
      var url = "";
      if (params.produtosDestaque) url = "item/sales/destaques/tabpre/";
      else if (params.produtosVarejo) url = "item/sales/varejo/tabpre/";
      else url = "item/sales/tabpre/";

      if (params.codtabpre) {
        url = url + params.codtabpre + "/";
      } else {
        url = url + "null/";
      }

      if (params.coditem) {
        url = url + params.coditem;
      } else {
        url = url + "pedido/";
        if (params.codpedv) {
          url = url + params.codpedv + "/";
        } else {
          url = url + "0/";
        }
      }
      const data = await apiORDS(this.getters.urlOrds + url, params);

      if (data.items) {
        commit("LOAD_ITEMSALESLIST", data);
      }
    },

    async loadItemSalesVarejo({ commit }, params) {
      var url = "";
      url = "item/sales/varejo/tabpre/";

      if (params.codtabpre) {
        url = url + params.codtabpre + "/";
      } else {
        url = url + "null/";
      }

      if (params.coditem) {
        url = url + params.coditem;
      } else {
        url = url + "pedido/";
        if (params.codpedv) {
          url = url + params.codpedv + "/";
        } else {
          url = url + "0/";
        }
      }

      console.log("chamada feita", url, params);
      const data = await apiORDS(this.getters.urlOrds + url, params);

      if (data.items) {
        commit("LOAD_ITEMSALESVAREJOLIST", data);
      }
    },

    async clearItemSales({ commit }) {
      commit("CLEAR_ITEMSALESLIST");
    },

    async clearItemVarejoSales({ commit }) {
      commit("CLEAR_ITEMSALESVAREJOLIST");
    },

    async clearItemList({ commit }) {
      commit("CLEAR_ITEMLIST");
    },

    async loadPesquisaProdutosSales({ commit }, params) {
      var url = "item/sales/pesquisa/produtos";
      const data = await apiORDS(this.getters.urlOrds + url, params);
      if (data.items) {
        commit("LOAD_ITEMSALESLIST", data);
      }
    },

    //CARREGA IMPOSTOS DO ITEM (INCLUSAO DE ITEM NA NF)
    async loadItemTaxes({ commit }, sendData) {
      const data = await apiORDSpost(
        this,
        "invoice/gettaxes/",
        sendData,
        "post"
      );
      if (data) {
        commit("LOAD_ITEMTAXES", data);
      }
    },

    //NATES
    async loadNates({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/nates/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_NATES", data);
        } else {
          commit("LOAD_NATESLIST", data);
        }
      }
    },

    //PEDIDO DE VENDA
    async loadPedvList({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "sales/pedv/", params);
      if (data.items) {
        commit("LOAD_PEDVLIST", data);
      }
    },

    async loadPedvTotal({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "sales/pedv/total/",
        params
      );
      if (data.items) {
        commit("LOAD_PEDVTOTAL", data);
      }
    },

    async loadPedv({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "sales/pedv/", params);
      if (data.items) {
        commit("LOAD_PEDV", data.items);
      }
    },

    async loadPedvAtualUsuario({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "sales/pedv/atualusuario/",
        params
      );
      if (data.items[0]) {
        commit("LOAD_PEDVATUALUSUARIO", data.items[0]);
      } else commit("LOAD_PEDVATUALUSUARIO", {});
    },

    // DEVOLUCAO VAREJO
    async loadVdevolPed({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "varejo/devolucao/pedido/",
        params
      );
      if (data) {
        commit("LOAD_VDEVOL", data);
      }
    },
    async loadVdevol({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "varejo/devolucao/",
        params
      );
      if (data) {
        commit("LOAD_VDEVOL", data);
      }
    },
    async loadvDevolList({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "varejo/devolucao/list",
        params
      );
      if (data) {
        commit("LOAD_VDEVOLLIST", data);
      }
    },

    //NOTA FISCAL
    async loadNfList({ commit }, params) {
      let modulo = "invoice/list/";
      if (params.operacao) {
        modulo = modulo + params.operacao;
      } else {
        modulo = modulo + "saida";
      }
      const data = await apiORDS(this.getters.urlOrds + modulo, params);
      if (data.items) {
        commit("LOAD_NFLIST", data);
      }
    },

    async loadCompraList({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + 'purchase/compra/', params)
      if (data.items) {
        commit('LOAD_COMPRALIST', data)
      }
    },

    async loadCompra({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + 'purchase/compra/', params)
      if (data.items) {
        commit('LOAD_COMPRA', data)
      }
    },

    async loadNf_with_itemList({ commit }, params) {
      let modulo = "invoice/list_with_item/";
      if (params.operacao) {
        modulo = modulo + params.operacao;
      } else {
        modulo = modulo + "saida";
      }
      const data = await apiORDS(this.getters.urlOrds + modulo, params);
      if (data.items) {
        commit("LOAD_NF_WITH_ITEMLIST", data);
      }
    },

    async loadListNf({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "invoice/listnf/",
        params
      );
      if (data.items) {
        commit("LOAD_LISTNF", data);
      }
    },

    async loadNf({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "invoice/nf/", params);
      if (data.items) {
        commit("LOAD_NF", data.items);
      }
    },

    async loadNf_impnfe({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "invoice/importxml/",
        params
      );
      if (data.items) {
        commit("LOAD_NF", data.items);
      }
    },

    async loadNfOrigem({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds +
        "invoice/origem/" +
        params.operacaoNf +
        "/" +
        params.codpart +
        "/",
        params
      );
      if (data.items) {
        commit("LOAD_NFORIGEM", data);
      }
    },

    //DI - DECLARACAO DE IMPORTACA
    async loadDiList({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "invoice/di/list/",
        params
      );
      if (data.items) {
        commit("LOAD_DILIST", data);
      }
    },

    async loadDi({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "invoice/di/", params);
      if (data.items) {
        commit("LOAD_DI", data.items);
      }
    },

    async loadDuimpList({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + 'invoice/duimp/list/', params)
      if (data.items) {
        commit('LOAD_DUIMPLIST', data)
      }
    },

    async loadDuimp({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + 'invoice/duimp/', params)
      if (data.items) {
        commit('LOAD_DUIMP', data.items)
      }
    },


    //UNIDADES DE MEDIDA
    async loadUnimedList({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/unimed/", params);
      if (data.items) {
        commit("LOAD_UNIMEDLIST", data.items);
      }
    },

    async loadUnimed({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/unimed/", params);
      if (data.items) {
        commit("LOAD_UNIMED", data.items[0]);
      }
    },

    //NCM
    async loadNcmList({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/ncm/", params);
      if (data.items) {
        commit("LOAD_NCMLIST", data);
      }
    },

    async loadNcm({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/ncm/", params);
      if (data.items) {
        commit("LOAD_NCM", data.items[0]);
      }
    },

    //GRUPOS DE ESTOQUE
    async loadGruest({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/gruest/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_GRUEST", data);
        } else {
          commit("LOAD_GRUESTLIST", data);
        }
      }
    },

    //GRUPOS DE FORNECEDOR
    async loadGrufor({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/grufor/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_GRUFOR", data);
        } else {
          commit("LOAD_GRUFORLIST", data);
        }
      }
    },

    //GRUPOS DE CLIENTE
    async loadGrucli({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/grucli/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_GRUCLI", data);
        } else {
          commit("LOAD_GRUCLILIST", data);
        }
      }
    },

    //XMLHIST
    async loadXMLHist({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/xmlhist/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_XMLHIST", data);
        } else {
          commit("LOAD_XMLHISTLIST", data);
        }
      }
    },

    async loadPdtipo({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/pdtipo/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_PDTIPO", data);
        } else {
          commit("LOAD_PDTIPOLIST", data);
        }
      }
    },
    async loadPdstatus({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "cg/pdstatus/",
        params,
        true
      );
      if (data.items) {
        if (params.id) {
          commit("LOAD_PDSTATUS", data);
        } else {
          commit("LOAD_PDSTATUSLIST", data);
        }
      }
    },
    async loadCondicao({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/condicao/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_CONDICAO", data);
        } else {
          commit("LOAD_CONDICAOLIST", data);
        }
      }
    },
    async loadEquipe({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "cg/equipe/",
        params,
        true
      );
      if (data.items) {
        if (params.id) {
          commit("LOAD_EQUIPE", data);
        } else {
          commit("LOAD_EQUIPELIST", data);
        }
      }
    },
    async loadAgenda({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/agenda/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_AGENDA", data);
        } else {
          commit("LOAD_AGENDALIST", data);
        }
      }
    },
    async loadCatmkt({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/catmkt/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_CATMKT", data);
        } else {
          commit("LOAD_CATMKTLIST", data);
        }
      }
    },

    //CRM
    async loadPessoa({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "crm/pessoa/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_PESSOA", data);
        } else {
          commit("LOAD_PESSOALIST", data);
        }
      }
    },

    async loadOrganizacao({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "crm/organizacao/",
        params
      );
      if (data.items) {
        if (params.id) {
          commit("LOAD_ORGANIZACAO", data);
        } else {
          commit("LOAD_ORGANIZACAOLIST", data);
        }
      }
    },

    async loadNegocio({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "crm/negocio/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_NEGOCIO", data);
        } else {
          commit("LOAD_NEGOCIOLIST", data);
        }
      }
    },

    async loadNegocioHist({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "crm/negocio/" + params.id + "/hist",
        null
      );
      if (data.items) {
        commit("LOAD_NEGOCIOHIST", data);
      }
    },

    async loadNegocioEmails({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "crm/email/list?codnegocio=" + params.id,
        null
      );
      if (data.items) {
        commit("LOAD_NEGOCIOEMAILS", data);
      }
    },

    async loadLead({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "crm/lead/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_LEADCRM", data);
        } else {
          commit("LOAD_LEADCRMLIST", data);
        }
      }
    },

    async loadEmailCrm({ commit }, params) {
      let url = this.getters.urlOrds + "crm/email/list";
      if (params.id) url = url + "?codemail=" + params.id;
      else if (params.codnegocio)
        url = url + "?codnegocio=" + params.codnegocio;
      else if (params.codpessoa) url = url + "?codpessoa=" + params.codpessoa;
      else if (params.codusuario)
        url = url + "?codusuario=" + params.codusuario;

      const data = await apiORDS(url, null);
      if (data.items)
        if (params.id) commit("LOAD_EMAILCRM", data);
        else commit("LOAD_EMAILCRMLIST", data);
    },

    async loadTemplEmail({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "crm/template/",
        params
      );
      if (data.items) {
        if (params.id) {
          commit("LOAD_TEMPLEMAIL", data);
        } else {
          commit("LOAD_TEMPLEMAILLIST", data);
        }
      }
    },

    async loadConfigCrm({ commit }) {
      const data = await apiORDS(this.getters.urlOrds + "crm/painel/config");
      if (data.items) {
        commit("LOAD_CONFIGCRM", data);
      }
    },

    async loadTagCrm({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "crm/tag/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_TAGCRM", data);
        } else {
          commit("LOAD_TAGCRMLIST", data);
        }
      }
    },

    async loadOrigemCrm({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "crm/origem/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_ORIGEMCRM", data);
        } else {
          commit("LOAD_ORIGEMCRMLIST", data);
        }
      }
    },

    async loadMotivoCrm({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "crm/motivo/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_MOTIVOCRM", data);
        } else {
          commit("LOAD_MOTIVOCRMLIST", data);
        }
      }
    },

    async loadFunilCrm({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "crm/funil/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_FUNILCRM", data);
        } else {
          commit("LOAD_FUNILCRMLIST", data);
        }
      }
    },

    async loadPainelCrm({ commit }, params) {
      let url = "";
      if (params.tipo == "timeline")
        url = "crm/painel/timeline/" + params.codfunil;
      else if (params.tipo == "lista")
        url = "crm/painel/" + params.codfunil + "/lista";
      else url = "crm/painel/" + params.codfunil + "/etapas/" + params.tipo;

      const data = await apiORDS(this.getters.urlOrds + url, params);

      if (data.items)
        if (params.tipo == "total") commit("LOAD_NEGOCIOTOTAIS", data);
        else commit("LOAD_NEGOCIOLIST", data);
    },

    async loadPainelNoDateTimelineListCrm({ commit }, params) {
      let url = "crm/painel/" + params.codfunil + "/lista/nodate";

      const data = await apiORDS(this.getters.urlOrds + url, params);

      if (data.items) commit("LOAD_NEGOCIONODATELIST", data);
    },

    //MENSAGENS NF
    async loadMennf({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/mennf/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_MENNF", data);
        } else {
          commit("LOAD_MENNFLIST", data);
        }
      }
    },

    //VENDEDORES
    async loadVend({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/vend/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_VEND", data);
        } else {
          commit("LOAD_VENDLIST", data);
        }
      }
    },

    //FILIAIS
    async loadFilial({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/filial/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_FILIAL", data);
        } else {
          commit("LOAD_FILIALLIST", data);
        }
      }
    },

    //USUARIOS
    async loadUsuario({ commit }, params) {
      const data = await apiORDS(this.getters.urlApp + "usuario/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_USUARIO", data);
        } else {
          commit("LOAD_USUARIOLIST", data);
        }
      }
    },

    //DEPOSITO
    async loadDeposito({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/deposito/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_DEPOSITO", data);
        } else {
          commit("LOAD_DEPOSITOLIST", data);
        }
      }
    },

    //ESTADOS
    async loadEstado({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/estado/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_ESTADO", data);
        } else {
          commit("LOAD_ESTADOLIST", data);
        }
      }
    },

    async loadEstadoRegras({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "cg/estado/regras/",
        params
      );
      if (data.items) {
        commit("LOAD_ESTADOLIST", data);
      }
    },

    //ivancm
    async loadivancm({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/ivancm/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_IVANCM", data);
        } else {
          commit("LOAD_IVANCMLIST", data);
        }
      }
    },

    //ivaclass
    async loadivaclass({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/ivaclass/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_IVACLASS", data);
        } else {
          commit("LOAD_IVACLASSLIST", data);
        }
      }
    },

    //REGRA ICMS ST
    async loadRegrast({ commit }, params) {
      var url = "cg/regrast/";
      if (params.path) {
        url = url + params.path;
      }
      const data = await apiORDS(this.getters.urlOrds + url, params);
      if (data.items) {
        commit("LOAD_REGRAST", data.items);
      }
    },

    async loadRegrastList({ commit }, params) {
      var url = "cg/regrast/";
      const data = await apiORDS(this.getters.urlOrds + url, params);
      if (data.items) {
        commit("LOAD_REGRASTLIST", data.items);
      }
    },

    //REGRAIMP
    async loadRegraimp({ commit }, params) {
      var url = "cg/regraimp/";
      if (params.path) {
        url = url + params.path;
      }
      const data = await apiORDS(this.getters.urlOrds + url, params);
      if (data.items) {
        commit("LOAD_REGRAIMP", data.items);
      }
    },

    async loadRegraimpList({ commit }, params) {
      var url = "cg/regraimp/";
      const data = await apiORDS(this.getters.urlOrds + url, params);
      if (data.items) {
        commit("LOAD_REGRAIMPLIST", data.items);
      }
    },

    //REGRAS FCP
    async loadRegrafcpList({ commit }, params) {
      var url = "cg/regrafcp/";
      const data = await apiORDS(this.getters.urlOrds + url, params);
      if (data.items) {
        commit("LOAD_REGRAFCPLIST", data);
      }
    },

    async loadRegrafcp({ commit }, params) {
      var url = "cg/regrafcp/";
      const data = await apiORDS(this.getters.urlOrds + url, params);
      if (data.items) {
        commit("LOAD_REGRAFCP", data);
      }
    },

    //GRUPO DE TRIBUTACAO
    async loadGrutribList({ commit }, params) {
      var url = "cg/grutrib/";
      const data = await apiORDS(this.getters.urlOrds + url, params);
      if (data.items) {
        commit("LOAD_GRUTRIBLIST", data);
      }
    },

    async loadGrutrib({ commit }, params) {
      var url = "cg/grutrib/";
      const data = await apiORDS(this.getters.urlOrds + url, params);
      if (data.items) {
        commit("LOAD_GRUTRIB", data);
      }
    },

    //SERIE NF
    async loadSerienf({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/serienf/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_SERIENF", data);
        } else {
          commit("LOAD_SERIENFLIST", data);
        }
      }
    },

    //CONTADOR
    async loadContador({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/contador/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_CONTADOR", data);
        } else {
          commit("LOAD_CONTADORLIST", data);
        }
      }
    },

    //NATUREZA FINANCEIRA
    async loadNatfin({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/natfin/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_NATFIN", data);
        } else {
          commit("LOAD_NATFINLIST", data);
        }
      }
    },

    //RAMO DE ATIVIDADE
    async loadRamoat({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/ramoat/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_RAMOAT", data);
        } else {
          commit("LOAD_RAMOATLIST", data);
        }
      }
    },

    //INUTILIZACOES
    async loadInut({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "invoice/inut/",
        params
      );
      if (data.items) {
        if (params.id) {
          commit("LOAD_INUT", data);
        } else {
          commit("LOAD_INUTLIST", data);
        }
      }
    },

    async loadNfAvisos({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "invoice/avisos/",
        params
      );
      if (data.items) {
        commit("LOAD_NFAVISOS", data);
      }
    },

    //conta bancaria
    async loadCta({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/cta/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_CTA", data);
        } else {
          commit("LOAD_CTALIST", data);
        }
      }
    },

    //formas de pagamento
    async loadFpag({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/fpag/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_FPAG", data);
        } else {
          commit("LOAD_FPAGLIST", data);
        }
      }
    },

    //caixa pdv
    async loadVCaixa({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/vcaixa/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_VCAIXA", data);
        } else {
          commit("LOAD_VCAIXALIST", data);
        }
      }
    },

    //bancos
    async loadBanco({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "fin/bancos/", params);
      if (data.items) {
        commit("LOAD_BANCO", data);
      }
    },

    //CNAB AR
    async loadCnabSemVinculo({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "cnab/ar/vincularconta/",
        params
      );
      if (data.items) {
        commit("LOAD_CNABSEMVINCULO", data);
      }
    },
    async loadCnabPendente({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "cnab/ar/pendencia/",
        params
      );
      if (data.items) {
        commit("LOAD_CNABPENDENTE", data);
      }
    },
    async loadCnabRetList({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "cnab/ar/retorno/",
        params
      );
      if (data.items) {
        commit("LOAD_CNABRETLIST", data);
      }
    },
    async loadCnabRetDetList({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "cnab/ar/retorno/",
        params
      );
      if (data.items) {
        commit("LOAD_CNABRETDETLIST", data);
      }
    },
    async loadCnabRemList({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "cnab/ar/remessa/",
        params
      );
      if (data.items) {
        commit("LOAD_CNABREMLIST", data);
      }
    },
    async loadCnabRejList({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "cnab/ar/rejeitados/",
        params
      );
      if (data.items) {
        commit("LOAD_CNABREJLIST", data);
      }
    },

    //FINACEIRO
    async loadFin({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "fin/movimento/",
        params
      );
      if (data.items) {
        if (params.id) {
          commit("LOAD_FIN", data);
        } else {
          commit("LOAD_FINARLIST", data);
        }
      }
    },

    async loadLogList({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "fin/log/", params);
      if (data.items) {
        commit("LOAD_LOG", data);
      }
    },

    //grade
    async loadGrade({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/grade/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_GRADE", data);
        } else {
          commit("LOAD_GRADELIST", data);
        }
      }
    },

    // Destaq
    async loadDestaq({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/destaq/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_DESTAQ", data);
        } else {
          commit("LOAD_DESTAQLIST", data);
        }
      }
    },

    // Tabdes
    async loadTabdes({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/tabdes/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_TABDES", data);
        } else {
          commit("LOAD_TABDESLIST", data);
        }
      }
    },

    //tabela de precos
    async loadTabpre({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "cg/tabpre/", params);
      if (data.items) {
        if (params.id) {
          commit("LOAD_TABPRE", data);
        } else {
          commit("LOAD_TABPRELIST", data);
        }
      }
    },

    //itens da tabela de preço
    async loadTabpreItens({ commit }, params) {
      let modulo = "cg/tabpre/" + params.id + "/produtos/";
      const data = await apiORDS(this.getters.urlOrds + modulo);
      if (data.items) {
        commit("LOAD_TABPREITENS", data);
      }
    },

    //docs/anexos
    async loadDocs({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "docs/", params);
      if (data.items) {
        commit("LOAD_DOCS", data);
      }
    },

    //MANIFESTO
    async loadManifesto({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "manifesto/pesquisar/",
        params
      );
      if (data.items) {
        if (params.id) {
          commit("LOAD_MANIFESTO", data);
        } else {
          commit("LOAD_MANIFESTOLIST", data);
        }
      }
    },

    async loadFrete({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrdsSelect + "frete/", params);
      if (data.items) {
        commit("LOAD_FRETELIST", data);
      }
    },

    //
    // FORCA DE VENDAS
    //
    async loadClientesFv({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "cg/part/forcavendas/clientes/",
        params
      );
      if (data.items) {
        if (params.id) {
          commit("LOAD_PART", data.items);
        } else {
          commit("LOAD_PARTLIST", data);
        }
      }
    },

    async loadPedidosFvList({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "sales/pedv/forcavendas/list/",
        params
      );
      //const data = await apiORDSgetViaPost(this.getters.urlOrds + 'sales/pedv/filtros/forcavendas/list/', params)
      if (data.items) {
        commit("LOAD_PEDVLIST", data);
      }
    },

    async loadPedidosFvTotal({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "sales/pedv/forcavendas/total/",
        params
      );
      //const data = await apiORDSgetViaPost(this.getters.urlOrds + 'sales/pedv/filtros/forcavendas/total/', params)
      if (data.items) {
        commit("LOAD_PEDVTOTAL", data);
      }
    },

    async loadGuiaNFe({ commit }) {
      const data = await apiORDS(this.getters.urlOrds + "cg/guianfe");
      if (data) {
        commit("LOAD_GUIANFE", data);
      }
    },
    async loadNotificationsList({ commit }, params) {
      const data = await apiORDS(
        this.getters.urlOrds + "cg/notifications/",
        params,
        true
      );
      if (data.items) {
        commit("LOAD_NOTIFICATIONSLIST", data);
      }
    },

    // LOJA

    async loadConfigLoja({ commit }, params) {
      const data = await apiORDS(this.getters.urlOrds + "loja/config/", params);
      if (data.items) {
        commit("LOAD_CONFIGLOJA", data);
      }
    },

    // FIM LOJA

    async loadTeste({ commit }, sendData, params) {
      const data = await apiORDSpost(
        this,
        "cg/teste/",
        sendData,
        "post",
        params
      );
      if (data) {
        commit("LOAD_TESTE", data);
      }
    },

    async cleanpart({ commit }) {
      commit("CLEAN_PART");
    }
  }
});



// WEBPACK FOOTER //
// ./src/shared/store.js